// extracted by mini-css-extract-plugin
export var fadeInOut = "_24-3";
export var icon = "_24-4";
export var savedIndicator = "_24-2";
export var savingIndicator = "_24-0";
export var spin = "_24-1";